import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
const useWindowWidth = (debounceDelay = 250) => {
    const [width, setWidth] = useState(0);
    useEffect(() => {
        setWidth(window.innerWidth);
        const handleResize = debounce(() => setWidth(window === null || window === void 0 ? void 0 : window.innerWidth), debounceDelay);
        window.addEventListener('resize', handleResize);
        return () => {
            window === null || window === void 0 ? void 0 : window.removeEventListener('resize', handleResize);
        };
    }, [debounceDelay]);
    return width;
};
export default useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map